export interface PagedResult<T> {
  content: T[];
  page: {
    totalElements: number,
    totalPages: number,
    number: number,
  }
}

export interface Pageable {
  /** page number, 0 based */
  page: number;
  /** size of page */
  size: number;
  sort?: Sort;
  search?: string;
}

export interface Sort {
  field: string;
  order: SortOrder;
}

export type SortOrder = 'asc' | 'desc';

export function emptyPage(): PagedResult<never> {
  return {
    content: [],
    page: {
      number: 0,
      totalElements: 0,
      totalPages: 0,
    },
  };
}

export function defaultPageable(): Pageable {
  return {
    page: 0,
    size: 10,
  };
}

export function fullPageable(): Pageable {
  return {
    page: 0,
    size: 10000,
  };
}

export function pageableWithSort(pageable: Pageable, sort: Sort): Pageable {
  return {
    ...pageable,
    sort: sort,
  };
}
